var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.headingTag,{tag:"component",class:['title-text', `title-text--level-${_vm.normalizedLevel}`],attrs:{"role":"heading","aria-level":_vm.level}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }